// Status de um conector do catálogo (H3, PO1-3261). Função pura.
//   'gerenciada'  → configurado pela Everlog (Neogrid, V360, Oracle): sem campos na tela.
//                   Vira 'ativa' quando o embarcador de fato usa: `ativoQuandoCampo`
//                   preenchido (Neogrid) ou embarcador em `embarcadoresAtivos` (V360);
//   'ativa'       → campoAtivador preenchido (senha: hasValue) — ou, na SEFAZ, há
//                   certificado A1 ativo e dentro da validade;
//   'disponivel'  → o resto ("Não configurado").
import { situacaoCertificado } from "../../../services/embarcadorCertificadoApi";
import { campoPreenchido } from "./conectores";

export const STATUS = { ATIVA: "ativa", DISPONIVEL: "disponivel", GERENCIADA: "gerenciada" };

export const ROTULO_STATUS = {
  ativa: "Ativa",
  disponivel: "Não configurado",
  gerenciada: "Gerenciado pela Everlog",
};

export const ROTULO_FILTRO = {
  todas: "Todas",
  ativa: "Ativas",
  disponivel: "Disponíveis",
  gerenciada: "Gerenciadas pela Everlog",
};

// Certificado "vale": ativo e não vencido (a faixa "vence em N dias" ainda vale).
export function certificadoValido(cert, agora) {
  if (!cert) return false;
  const s = situacaoCertificado(cert, agora);
  return s.chave === "ativo" || s.chave === "vencendo";
}

export function temCertificadoValido(certificados, agora) {
  const lista = Array.isArray(certificados) ? certificados : certificados ? [certificados] : [];
  return lista.some((c) => certificadoValido(c, agora));
}

function gerenciadoAtivo(conector, formulario, embarcadorId) {
  if (Array.isArray(conector.embarcadoresAtivos) && conector.embarcadoresAtivos.indexOf(Number(embarcadorId)) !== -1) return true;
  if (!conector.ativoQuandoCampo) return false;
  const param = (formulario || []).find((p) => p && p.nome === conector.ativoQuandoCampo);
  return campoPreenchido(param);
}

export function statusDoConector(conector, formulario, certificado, agora, embarcadorId) {
  if (!conector) return STATUS.DISPONIVEL;
  if (conector.gerenciado) return gerenciadoAtivo(conector, formulario, embarcadorId) ? STATUS.ATIVA : STATUS.GERENCIADA;
  if (conector.usaCertificado) return temCertificadoValido(certificado, agora) ? STATUS.ATIVA : STATUS.DISPONIVEL;
  if (!conector.campoAtivador) return STATUS.DISPONIVEL;
  const param = (formulario || []).find((p) => p && p.nome === conector.campoAtivador);
  return campoPreenchido(param) ? STATUS.ATIVA : STATUS.DISPONIVEL;
}

export function contarPorStatus(conectores, formulario, certificado, agora, embarcadorId) {
  const contagem = { todas: 0, ativa: 0, disponivel: 0, gerenciada: 0 };
  (conectores || []).forEach((c) => {
    contagem.todas += 1;
    contagem[statusDoConector(c, formulario, certificado, agora, embarcadorId)] += 1;
  });
  return contagem;
}
